<template>

    <div :id="cardListId" class="cards_list_wrapper">

        <div class="cards_list">

            <slot name="cardsList" ></slot>

        </div>

        <slot name="cardsListHelpers" ></slot>

    </div>

</template>

<script>
export default {
    name: 'CardsListWrapper',
    props: {
        cardListId: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.cards_list_wrapper{
    .cards_list{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-start;
    }
}

</style>